// extracted by mini-css-extract-plugin
export default {"button":"WriteButton_button__Hy+3m"};